export enum CurrencyEnum {
  SEK = 1,
  EUR
}